import axiosInstance from "./AxiosInstance";

export function getSystemLogApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/system-logs?${fparam}`)
}

export function getSystemLogExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/system-logs?${fparam}`, {
    responseType: "blob",
  });
}